/**
 * theme.js — The Fluent Hafidh
 * Grouped by feature area, module pattern, no global scope pollution.
 */

(() => {
  'use strict';

  // ===========================
  // Intersection Observer — fade-up
  // ===========================
  const initFadeUp = () => {
    const fadeEls = document.querySelectorAll('.fade-up');
    const io = new IntersectionObserver((entries) => {
      for (const entry of entries) {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          io.unobserve(entry.target);
        }
      }
    }, { threshold: 0.1, rootMargin: '0px 0px -48px 0px' });

    for (const el of fadeEls) io.observe(el);

    // Hero fires immediately on load
    window.addEventListener('DOMContentLoaded', () => {
      const heroEls = document.querySelectorAll('.hero .fade-up');
      heroEls[0] && setTimeout(() => heroEls[0].classList.add('visible'), 80);
      heroEls[1] && setTimeout(() => heroEls[1].classList.add('visible'), 260);
    });
  };

  // ===========================
  // Nav — tighten on scroll
  // ===========================
  const initNav = () => {
    const navEl = document.getElementById('Nav');
    if (!navEl) return;
    window.addEventListener('scroll', () => {
      navEl.style.background = window.scrollY > 30
        ? 'rgba(250,250,247,0.99)'
        : 'rgba(250,250,247,0.96)';
      navEl.style.boxShadow = window.scrollY > 30
        ? '0 2px 20px rgba(0,0,0,0.1)'
        : '0 1px 12px rgba(0,0,0,0.06)';
    }, { passive: true });
  };

  // ===========================
  // Email Form Submit
  // ===========================
  const initEmailForm = () => {
    const emailForm = document.getElementById('EmailForm');
    if (!emailForm) return;
    emailForm.addEventListener('submit', (e) => {
      e.preventDefault();
      const input = document.getElementById('EmailInput');
      const btn   = emailForm.querySelector('button[type="submit"]');
      if (input.value && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(input.value)) {
        btn.textContent       = "✓ You're on the list!";
        btn.style.background  = '#1A6644';
        btn.style.boxShadow   = 'none';
        input.disabled        = true;
        btn.disabled          = true;
      } else {
        input.style.borderColor = '#B45309';
        input.focus();
        setTimeout(() => { input.style.borderColor = ''; }, 1800);
      }
    });
  };

  // ===========================
  // Smooth anchor offset (nav height)
  // ===========================
  const initSmoothScroll = () => {
    for (const link of document.querySelectorAll('a[href^="#"]')) {
      link.addEventListener('click', (e) => {
        const id     = link.getAttribute('href').slice(1);
        const target = document.getElementById(id);
        if (target) {
          e.preventDefault();
          const top = target.getBoundingClientRect().top + window.scrollY - 80;
          window.scrollTo({ top, behavior: 'smooth' });
        }
      });
    }
  };

  // ===========================
  // Init all modules
  // ===========================
  initFadeUp();
  initNav();
  initEmailForm();
  initSmoothScroll();

  // ===========================
  // Lucide Icons
  // ===========================
  if (typeof lucide !== 'undefined') lucide.createIcons();
})();
